export default "__VITE_ASSET__CCGguCpo__"